import React, { useEffect, useState } from 'react';
import api from '../../services/api';

const VACIO = { nombre: '', codigo: '', descripcion: '', km_aproximados: '', lote: 'lote2' };

export default function Servicios() {
  const [locomotoras, setLocomotoras] = useState([]);
  const [recorridos, setRecorridos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalAsignar, setModalAsignar] = useState(null);
  const [modalServicio, setModalServicio] = useState(null);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState(VACIO);
  const [formAsignar, setFormAsignar] = useState({ recorrido_id: '', desde: new Date().toISOString().split('T')[0] });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    setLoading(true);
    Promise.all([api.get('/locomotoras/'), api.get('/recorridos/')]).then(([l, r]) => {
      setLocomotoras(l.data.filter(l => l.activa));
      setRecorridos(r.data.filter(r => r.activo));
    }).finally(() => setLoading(false));
  };

  const abrirNuevo = () => { setEditando(null); setForm(VACIO); setModalServicio(true); };
  const abrirEditar = (r) => {
    setEditando(r);
    setForm({ nombre: r.nombre, codigo: r.codigo, descripcion: r.descripcion || '', km_aproximados: r.km_aproximados || '', lote: r.lote || 'lote2' });
    setModalServicio(true);
  };

  const guardarServicio = async () => {
    if (!form.nombre || !form.codigo) { setMsg('Nombre y codigo son obligatorios'); return; }
    setSaving(true);
    try {
      if (editando) {
        await api.patch(`/recorridos/${editando.id}`, form);
        setMsg('Servicio actualizado');
      } else {
        await api.post('/recorridos/', form);
        setMsg('Servicio creado');
      }
      setModalServicio(false);
      cargar();
      setTimeout(() => setMsg(''), 3000);
    } catch (e) {
      setMsg(e.response?.data?.detail || 'Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  const darBaja = async (r) => {
    if (!window.confirm(`Dar de baja el servicio ${r.codigo}?`)) return;
    await api.delete(`/recorridos/${r.id}`);
    setMsg(`${r.codigo} dado de baja`);
    cargar();
    setTimeout(() => setMsg(''), 3000);
  };

  const abrirAsignar = (loco) => {
    setModalAsignar(loco);
    setFormAsignar({ recorrido_id: loco.servicio_asignado?.id || '', desde: new Date().toISOString().split('T')[0] });
  };

  const guardarAsignacion = async () => {
    setSaving(true);
    try {
      await api.post('/recorridos/asignar', {
        locomotora_id: modalAsignar.id,
        recorrido_id: formAsignar.recorrido_id ? parseInt(formAsignar.recorrido_id) : null,
        desde: formAsignar.desde
      });
      setMsg('Servicio asignado correctamente');
      setModalAsignar(null);
      cargar();
      setTimeout(() => setMsg(''), 3000);
    } catch (e) {
      setMsg('Error al asignar');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div style={{ padding: 40, color: '#888' }}>Cargando...</div>;

  const lote1 = recorridos.filter(r => r.lote === 'lote1');
  const lote2 = recorridos.filter(r => r.lote === 'lote2');
  const exploradoras = locomotoras.filter(l => l.tipo === 'exploradora');
  const ferrovial = locomotoras.filter(l => l.tipo === 'ferrovial');

  const renderTablaServicios = (lista, titulo) => (
    <div style={{ marginBottom: 16 }}>
      <div style={{ fontSize: 11, fontWeight: 500, color: '#888', textTransform: 'uppercase', letterSpacing: 0.5, padding: '8px 14px', background: '#f8f8f6', borderBottom: '1px solid #e5e5e5' }}>
        {titulo} — {lista.length} servicios
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ background: '#f8f8f6' }}>
            <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Codigo</th>
            <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Nombre</th>
            <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Descripcion</th>
            <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>KM/dia</th>
            <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {lista.map(r => (
            <tr key={r.id} style={{ borderTop: '1px solid #f0f0f0' }}>
              <td style={{ padding: '10px 14px', fontWeight: 500 }}>{r.codigo}</td>
              <td style={{ padding: '10px 14px' }}>{r.nombre}</td>
              <td style={{ padding: '10px 14px', color: '#888', fontSize: 12 }}>{r.descripcion || '—'}</td>
              <td style={{ padding: '10px 14px' }}>{r.km_aproximados} km</td>
              <td style={{ padding: '10px 14px' }}>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button onClick={() => abrirEditar(r)} style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 12 }}>Editar</button>
                  <button onClick={() => darBaja(r)} style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #fcc', background: '#fff5f5', cursor: 'pointer', fontSize: 12, color: '#c00' }}>Baja</button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderBloqueLocomotoras = (lista, titulo) => (
    lista.length > 0 && (
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 13, fontWeight: 500, color: '#555', marginBottom: 10 }}>{titulo}</div>
        <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f8f8f6' }}>
                <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Locomotora</th>
                <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Servicio asignado</th>
                <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Lote</th>
                <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>KM/dia</th>
                <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Desde</th>
                <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(l => (
                <tr key={l.id} style={{ borderTop: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '10px 14px', fontWeight: 500 }}>{l.numero}</td>
                  <td style={{ padding: '10px 14px' }}>
                    {l.servicio_asignado
                      ? <div><span style={{ fontWeight: 500 }}>{l.servicio_asignado.codigo}</span><span style={{ color: '#888', fontSize: 11, marginLeft: 6 }}>{l.servicio_asignado.nombre}</span></div>
                      : <span style={{ color: '#aaa', fontSize: 12 }}>Sin asignar</span>}
                  </td>
                  <td style={{ padding: '10px 14px' }}>
                    {l.servicio_asignado?.lote
                      ? <span style={{ background: l.servicio_asignado.lote === 'lote1' ? '#e6f1fb' : '#eaf3de', color: l.servicio_asignado.lote === 'lote1' ? '#185fa5' : '#3b6d11', borderRadius: 20, padding: '2px 8px', fontSize: 11, fontWeight: 500 }}>
                          {l.servicio_asignado.lote === 'lote1' ? 'Lote 1' : 'Lote 2'}
                        </span>
                      : '—'}
                  </td>
                  <td style={{ padding: '10px 14px', color: '#555' }}>{l.servicio_asignado ? `${l.servicio_asignado.km_aproximados} km` : '—'}</td>
                  <td style={{ padding: '10px 14px', color: '#888', fontSize: 12 }}>{l.servicio_desde || '—'}</td>
                  <td style={{ padding: '10px 14px' }}>
                    <button onClick={() => abrirAsignar(l)} style={{ padding: '5px 12px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 12 }}>
                      Asignar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )
  );

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
        <div>
          <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>Servicios</h2>
          <p style={{ fontSize: 13, color: '#888', marginTop: 4 }}>Gestion de servicios y asignacion a locomotoras</p>
        </div>
        <button onClick={abrirNuevo} style={{ padding: '9px 18px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}>
          + Nuevo servicio
        </button>
      </div>

      {msg && <div style={{ background: '#eaf3de', border: '1px solid #97c459', borderRadius: 8, padding: '10px 16px', marginBottom: 16, fontSize: 13, color: '#3b6d11' }}>{msg}</div>}

      <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', overflow: 'hidden', marginBottom: 24 }}>
        <div style={{ padding: '12px 16px', borderBottom: '1px solid #e5e5e5', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 13, fontWeight: 500 }}>Servicios disponibles</span>
          <span style={{ fontSize: 12, color: '#888' }}>{recorridos.length} total</span>
        </div>
        {lote1.length > 0 && renderTablaServicios(lote1, 'Lote 1')}
        {lote2.length > 0 && renderTablaServicios(lote2, 'Lote 2')}
      </div>

      {renderBloqueLocomotoras(exploradoras, 'Exploradoras')}
      {renderBloqueLocomotoras(ferrovial, 'Ferrovial')}

      {modalServicio && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}
          onClick={e => { if (e.target === e.currentTarget) setModalServicio(false); }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 440, maxWidth: '95vw' }}>
            <h3 style={{ fontSize: 16, fontWeight: 500, marginBottom: 20 }}>{editando ? `Editar — ${editando.codigo}` : 'Nuevo servicio'}</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Codigo *</label>
                <input value={form.codigo} onChange={e => setForm({ ...form, codigo: e.target.value })}
                  placeholder="Ej: MDC" style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>KM/dia</label>
                <input type="number" value={form.km_aproximados} onChange={e => setForm({ ...form, km_aproximados: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Nombre *</label>
              <input value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })}
                placeholder="Ej: Monforte del Cid - Chinchilla"
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Lote</label>
              <select value={form.lote} onChange={e => setForm({ ...form, lote: e.target.value })}
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
                <option value="lote1">Lote 1</option>
                <option value="lote2">Lote 2</option>
              </select>
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Descripcion</label>
              <textarea value={form.descripcion} onChange={e => setForm({ ...form, descripcion: e.target.value })}
                rows={2} placeholder="Estaciones del recorrido..."
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13, resize: 'none', boxSizing: 'border-box' }} />
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setModalServicio(false)} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>Cancelar</button>
              <button onClick={guardarServicio} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, opacity: saving ? 0.7 : 1 }}>
                {saving ? 'Guardando...' : editando ? 'Guardar cambios' : 'Crear servicio'}
              </button>
            </div>
          </div>
        </div>
      )}

      {modalAsignar && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}
          onClick={e => { if (e.target === e.currentTarget) setModalAsignar(null); }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 400, maxWidth: '95vw' }}>
            <h3 style={{ fontSize: 16, fontWeight: 500, marginBottom: 6 }}>Asignar servicio — {modalAsignar.numero}</h3>
            <p style={{ fontSize: 12, color: '#888', marginBottom: 20 }}>
              {modalAsignar.servicio_asignado ? `Servicio actual: ${modalAsignar.servicio_asignado.codigo}` : 'Sin servicio asignado'}
            </p>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Servicio</label>
              <select value={formAsignar.recorrido_id} onChange={e => setFormAsignar({ ...formAsignar, recorrido_id: e.target.value })}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
                <option value="">Sin servicio</option>
                {['lote1', 'lote2'].map(lote => (
                  <optgroup key={lote} label={lote === 'lote1' ? 'Lote 1' : 'Lote 2'}>
                    {recorridos.filter(r => r.lote === lote).map(r => (
                      <option key={r.id} value={r.id}>{r.codigo} — {r.nombre} ({r.km_aproximados} km)</option>
                    ))}
                  </optgroup>
                ))}
              </select>
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Fecha inicio</label>
              <input type="date" value={formAsignar.desde} onChange={e => setFormAsignar({ ...formAsignar, desde: e.target.value })}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setModalAsignar(null)} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>Cancelar</button>
              <button onClick={guardarAsignacion} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, opacity: saving ? 0.7 : 1 }}>
                {saving ? 'Guardando...' : 'Asignar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
